export default {
    country: 4,
    province: 7,
    city: 9,
    district: 11,
}